export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_SET_ACCESS_TOKEN = 'AUTH_SET_ACCESS_TOKEN'
export const AUTH_SEND_EMAIL_CONFIGURATION_CODE = 'AUTH_SEND_EMAIL_CONFIGURATION_CODE'
export const AUTH_VALIDATE_TWO_FACTOR_AUTHENTICATION_CODE = 'AUTH_VALIDATE_TWO_FACTOR_AUTHENTICATION_CODE'
export const AUTH_TWO_FACTOR_AUTHENTICATION_SUCCESS = 'AUTH_TWO_FACTOR_AUTHENTICATION_SUCCESS'
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const RESET_CHANGE_PASSWORD_STATUS = 'RESET_CHANGE_PASSWORD_STATUS'
export const CLIENT_TOKEN_ERROR = 'CLIENT_TOKEN_ERROR'
export const CLIENT_TOKEN_REQUEST = 'CLIENT_TOKEN_REQUEST'
export const CLIENT_TOKEN_SUCCESS = 'CLIENT_TOKEN_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const TERMS_AND_CONDITIONS_ERROR = 'TERMS_AND_CONDITIONS_ERROR'
export const TERMS_AND_CONDITIONS_REQUEST = 'TERMS_AND_CONDITIONS_REQUEST'
export const TERMS_AND_CONDITIONS_REQUIRED = 'TERMS_AND_CONDITIONS_REQUIRED'
export const TERMS_AND_CONDITIONS_SUCCESS = 'TERMS_AND_CONDITIONS_SUCCESS'
export const PASSWORD_ROTATION_UPDATED = 'PASSWORD_ROTATION_UPDATED'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_GUEST = 'SET_GUEST'
